// Networking acronyms that should render fully upper-cased rather than
// title-cased (so `set_mstp_instance_vlan` → "Set MSTP Instance VLAN", not
// "Set Mstp Instance Vlan"). Keys are the lower-cased snake_case token.
const ACRONYMS: Record<string, string> = {
  mstp: 'MSTP',
  stp: 'STP',
  rstp: 'RSTP',
  vstp: 'VSTP',
  vlan: 'VLAN',
  vlans: 'VLANs',
  dns: 'DNS',
  dhcp: 'DHCP',
  snmp: 'SNMP',
  ntp: 'NTP',
  svi: 'SVI',
  lldp: 'LLDP',
  cdp: 'CDP',
  lacp: 'LACP',
  lag: 'LAG',
  bgp: 'BGP',
  ospf: 'OSPF',
  vrf: 'VRF',
  acl: 'ACL',
  qos: 'QoS',
  ip: 'IP',
  ipv4: 'IPv4',
  ipv6: 'IPv6',
  mac: 'MAC',
  mtu: 'MTU',
  poe: 'PoE',
  sys: 'System',
  id: 'ID',
  url: 'URL',
  ssh: 'SSH',
  tls: 'TLS',
  ssl: 'SSL',
  bpdu: 'BPDU',
  mst: 'MST',
};

function titleizeToken(word: string): string {
  if (word === '') return word;
  const acronym = ACRONYMS[word.toLowerCase()];
  if (acronym) return acronym;
  return word.charAt(0).toUpperCase() + word.slice(1);
}

/** Turn a snake_case operation name into a human title, upper-casing known
 * networking acronyms (MSTP, VLAN, DNS, …). */
export function formatOperationName(name: string): string {
  return name.split('_').map(titleizeToken).join(' ');
}

/** Turn a snake_case variable name into a human label, upper-casing known
 * networking acronyms. */
export function formatVariableName(name: string): string {
  return name.split('_').map(titleizeToken).join(' ');
}

/** Display name for an operation: its profile-declared `title` when present,
 * otherwise a formatted `operationName`. */
export function operationTitle(op: { title?: string | null; operationName: string }): string {
  return op.title ?? formatOperationName(op.operationName);
}

/** "N device(s)": how many devices a site-scoped operation reaches. */
export function deviceCount(n: number): string {
  return `${String(n)} ${n === 1 ? 'device' : 'devices'}`;
}
